// extracted by mini-css-extract-plugin
module.exports = {"footerFoot":"footer-module--footerFoot--Z-EZ6","BCLogo":"footer-module--BCLogo--1_kHz"};